import Vue from 'vue'
import Router from 'vue-router'
import PageBi from '@/pages/PageBi'
import store from '@/store'
import PageLogin from '@/pages/PageLogin'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: PageLogin
    },
    {
      path: '/',
      name: 'page_bi',
      component: PageBi,
      beforeEnter: requireAuth
    }
  ]
})
async function requireAuth (to, from, next) {
  if (!store.state.auth.authenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js